import React from 'react';
import style from '@src/js/Style';
import MortgageCost from './MortgageCost';
import NumberFormatter from '../../NumberFormatter';
import Input from '../Form/Input';
import TooltipNative from '@src/js/Components/Base/Tooltip';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, LinearScale } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend, LinearScale);

export default class MortgageService extends MortgageCost {

    componentDidUpdate() {

        super.componentDidUpdate();

        this.getDetailsData().forEach((item) => {

            if (item.name == undefined && item.props?.node != undefined)
                item.props.node.setValue(item.props.value);
        });

        if (this.nodes.chart) {

            this.nodes.chart.data = this.getChartData();
            this.nodes.chart.update('none');
        }
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    renderPart2() {

        const
            data = this.getDetailsData(),
            chartData = this.getChartData();

        return (
            <div className={ style('w-full flex flex-wrap gap-lg loader') }
                ref={ (node) => { this.nodes.details = node; } }>
                
                {/* chart */}
                <div className={ style('size-280 relative') }>
                    <Doughnut
                        style={{ position: 'relative', zIndex: 1000 }}
                        ref={ (node) => { this.nodes.chart = node; } }
                        options={ this.getChartOptions() }
                        data={ chartData } />
                    <div className={ style('absolute-center') }>
                        <div className={ style('text-small w-full text-center') }>
                            { this.form.state.result.payment.label }
                        </div>
                        <div className={ style('title1 w-full text-center') }>
                            { this.form.state.result.payment.value.formatted() }
                        </div>
                    </div>
                </div>
                
                {/* chart legend */}
                <div className={ style('flex-grid-1 w-full') }>
                    { data.map((item) => this.renderLegend(item.color, item.props, item.name ?? null)) }
                </div>

                {/* payment sum */}
                <div className={ style('flex w-full justify-between text-medium') }>
                    <div>{ this.state.details.sumPayment.label }</div>
                    <div className={ style('flex-1 text-right loader__child') }>
                        { this.state.details.sumPayment.value.formatted() }
                    </div>
                </div>

            </div>
        );
    }

    renderFooter() {

        return this.renderControls(false, style('flex-grid-4 items-center mt-12'));
    }

    renderLegend(color, props, name) {

        const classes = ['text-right text-small'];
        if (name == undefined)
            classes.push('form-control--text loader__child');

        return (
            <div key={ props.label } className={ style('grid-2 items-center gap-md justify-between') }>

                <div className={ style('flex items-center gap-md text-small') }>
                    <i className={ style('rounded-full size-16 aspect-square') } style={{ backgroundColor: color }}></i>
                    <div className={ style('flex items-center') }>
                        <div>{ props.label }</div>
                        { props.tooltip ? <TooltipNative>{ props.tooltip }</TooltipNative> : null }
                    </div>
                </div>

                {
                    <Input
                        className={ style(classes.join(' ')) }
                        ref={ (node) => { props.node = node; } }
                        onChange={ () => { props.value = NumberFormatter.parse(props.node.value); } }
                        name={ name }
                        format='number'
                        suffix={ this.state.currency }
                        min={ props.min }
                        max={ props.max }
                        value={ props.value } />
                }

            </div>
        );
    }

    //------------------------------------------------------------------------------------------------------------------
    // GETTERS
    //------------------------------------------------------------------------------------------------------------------

    getChartOptions() {

        return {
            cutout: 100,
            animation: {
                duration: 0,
            },
        };
    }

    getChartData() {
        
        const

            data = this.getDetailsData(),

            chartData = {
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                    },
                ],
            };

        data.forEach((item) => {

            chartData.datasets[0].data.push(item.props.value.toFloat());
            chartData.datasets[0].backgroundColor.push(item.color);
        });

        return chartData;
    }

    getDetailsData() {
        
        return [
            {
                color: '#1373E5',
                props: this.state?.details?.sumWithoutOverpayment,
            },
            {
                color: '#9556D3',
                props: this.state?.details?.sumOverpayment,
            },
            {
                color: '#E3405E',
                props: this.state?.details?.insurance,
                name: 'insurance',
            },
            {
                color: '#FABD48',
                props: this.state?.details?.other,
                name: 'other',
            },
            {
                color: '#10B97B',
                props: this.state?.details?.tax,
                name: 'tax',
            },
            {
                color: '#B1815E',
                props: this.state?.details?.commission,
                name: 'commission',
            },
        ];
    }
}